import { MatDialog } from '@angular/material/dialog';
import _ from 'lodash';
import { PopupComponent } from '../components/popup/popup.component';
import { ComponentTypes,ActivitiesVenue,AnyVenue } from '../constants/commonenums';
import { ComponentDetails } from '../dynamicform/models/popup.interface';
import { AddonActivitiesMappingsDTO, AddonDTO, AddOnAvailability, SelectionType, WidgetSettingsDTO } from '../Models/WidgetSettingsModels';
import moment from 'moment';

export abstract class Utilities {
  constructor(protected dialog: MatDialog,) { }

  public openCustomPopup(componentDetails: ComponentDetails, fromComponent: ComponentTypes, width?: string, height?: string,
    back?: boolean, title?: string, update?: string, cancel?: string, showAction?: boolean, maxWidth?: string,
    panelClass?: string, selectionView?: boolean, disabled?: boolean) {
    const dialogRef = this.dialog.open(PopupComponent, {
      disableClose: true,
      width,
      height,
      maxWidth,
      panelClass,
      minHeight: 100,
      data: {
        title,
        update,
        cancel,
        componentDetails,
        from: fromComponent,
        back,
        standalone: true,
        showAction,
        selectionView,
        disabled
      }
    });
    return dialogRef;
  }

  public static setComponentDetails(componentName: any, dimensionType: string, popupType: string, popupInput?: any,
    popupTitle?: any): ComponentDetails {
    const componentDetails: ComponentDetails = {
      componentName,
      dimensionType,
      popupType,
      popUpDetails: {
        eventName: 'notifyParent'
      },
      popupInput,
      popupTitle: popupTitle ? popupTitle : ''
    };
    return componentDetails;
  }

  public static getRandomDecimal(): number {
    const crypto = window.crypto;
    return crypto.getRandomValues(new Uint32Array(1))[0] / 2 ** 32;
  }

  public static getDefaultCountry(countryCodes: any[], country: string) {
    let restaurantCountry = country;
    let defaultCountry: any;
    if (restaurantCountry.toLowerCase() === 'england' ||
      restaurantCountry.toLowerCase() === 'scotland' || restaurantCountry.toLowerCase() === 'wales') {
      restaurantCountry = 'United kingdom';
    }
    const matchedCountry = countryCodes.filter((country) => {
      return country.Name.toLowerCase() === restaurantCountry.toLowerCase();
    });
    if (matchedCountry.length > 0) {
      defaultCountry = matchedCountry[0];
    } else {
      defaultCountry = countryCodes.filter((country) => country.Name === 'USA')[0];
    }
    return defaultCountry;
  }

  public static Date(date?: any) {
    return date ? moment(date) : moment();
  }

  public static datetimeBetween(start: Date, end: Date, date: Date): boolean {
    return (new Date(date) >= new Date(start) && new Date(date) <= new Date(end));
  }

  public static diffBetweenDates(start, end): number {
    return this.Date(start).startOf('d').diff(this.Date(end).startOf('d'), 'd');
  }
  public static diffBetweenDatesInMinutes(start, end): number {
    return this.Date(start).startOf('m').diff(this.Date(end).startOf('m'), 'm');
  }

  public static diffBetweenDateTime(start: Date, end: Date) {
    return this.Date(start).diff(end);
  }

  public static uniqueBy(arr, ...uniqueByArgs) {
    let modifiedArray = arr.map(item => {
      let res = "";
      uniqueByArgs.forEach((prop, index) => {
        if (index) {
          res += "||";
        }
        res += item[prop];
      })
      return res;
    });
    var uniqueArray = [...new Set(modifiedArray)];
    return uniqueArray.map((item: string) => {
      var values = item.split("||");
      var output = {};
      uniqueByArgs.forEach((prop, index) => {
        output[prop] = values[index]
      })
      return output;
    })
  }

  public static parseDateString(date: Date | string) {
    return new Date(moment(date).valueOf());
  }

  public static getRestaurantDateTime(setting: string, customDate?:Date) {
    const offset = Number(setting);
    const d = customDate ? customDate : new Date();
    const utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    const nd = new Date(utc + (3600000 * offset));
    return customDate ? new Date(nd.valueOf()) : nd;
  }
  public static IsActivitiesVenues(type){
    return ActivitiesVenue.find(x => x == type) ? true : false;
  }
  public static AnyVenue(type){
    return AnyVenue.find(x => x == type) ? true : false;
  }

  static getAddons(AddonsList: AddonDTO[], SpecialMeal: any, isNonDining?: boolean) {
    let AddonActivitiesMappings: AddonActivitiesMappingsDTO[] = [];
    if(SpecialMeal) isNonDining = false;
    if (!AddonsList) {
      return null
    }
    // let Addons = AddonsList.filter(x => x.AddonActivitiesMappings.some(g => g.ActivityId == SpecialMeal));
    if(!isNonDining && SpecialMeal)
    AddonsList.forEach(y => {
      y.AddonActivitiesMappings.forEach(x => {
        if (x.ActivityId == SpecialMeal && x.AvailableForWebReservation)
          AddonActivitiesMappings.push(x);
      })
    });
    else 
    AddonsList.forEach(y => {
      y.AddonActivitiesMappings.forEach(x => {
        if (!x.ActivityId && x.AvailableForWebReservation)
          AddonActivitiesMappings.push(x);
      })
    });

    return AddonActivitiesMappings;
  }

  static getMandatoryAddons(AddonsList: AddonDTO[], SpecialMeal?) {
    let AddonActivitiesMappings: AddonActivitiesMappingsDTO[] = [];
    // let Addons = AddonsList.filter(x => x.AddonActivitiesMappings.some(g => g.ActivityId == SpecialMeal && g.IsMandatory == true));
    if (!AddonsList) {
      return null
    }
    AddonsList.forEach(y => {
      y.AddonActivitiesMappings.forEach(x => {
        if (x.ActivityId == SpecialMeal && (x.IsMandatory || x.IsCategoryLevelMandatory) && x.AvailableForWebReservation)
          AddonActivitiesMappings.push(x);
      })
    });
    return AddonActivitiesMappings;
  }

  static getSelectedAddOns(addOnList)
  {
    let selectedAddOns: any = addOnList.filter(x => x.selectedQuantity > 0);
    return selectedAddOns?.map(addOn => { return { AddonId : addOn.AddonId, Quantity: addOn.selectedQuantity, Category: addOn.PricingCategory}});
  }


  static filterSlotsbyAddon(AddonsList: AddonDTO[], OverAllAddon: AddonActivitiesMappingsDTO[], Addons: AddonActivitiesMappingsDTO[], AvailableAddon: AddOnAvailability[], selectedPartySize,SpecialMealId) {
    if (!OverAllAddon
      || (OverAllAddon && OverAllAddon.length == 0)//When there is no addon-activity mapping, we shouldn't disable slots
      || !AvailableAddon || Addons.length == 0
      ) {
      return true;
    } 

    let addonvalue = false;
    let alreadycheckval = [];
    let categoryleveladdons = Addons.filter(x => x.IsCategoryLevelMandatory);
	  Addons = Addons.filter(x => x.AvailableForWebReservation);
    for (const addon of Addons) {
      if (alreadycheckval.find(x => x.AddonId == addon.AddonId))
        continue;
      let byPartyType = false;
      let byPerBooking = false;
      let byLessonType = false;
      let anyCategoryforBooking = false;
      let addons = AddonsList.filter(x => x.AddonId == addon.AddonId)[0];
      const val = AvailableAddon?.filter(z => z.AddonId == addon.AddonId)[0];
      if (addons && val && addon.IsMandatory && addons.SelectionType == SelectionType.PerGuest) {
        byPartyType = val.AvailableQuantity >= selectedPartySize && (addon.MinQuantity <= selectedPartySize && addon.MaxQuantity >= selectedPartySize);
      }
      if (addons && val && addon.IsMandatory && addons.SelectionType == SelectionType.PerBooking) {
        byPerBooking = val.AvailableQuantity >= addon.MinQuantity;
      } 
      if (addons && val && addon.IsMandatory && addons.SelectionType == SelectionType.PerLesson) {
        byLessonType = val.AvailableQuantity <= val.OverAllQuantity && val.AvailableQuantity > 0;
      }
      if (addons && val && addon.IsCategoryLevelMandatory) {
        let Categoryaddons = AddonsList.filter(x => x.CategoryId == addons.CategoryId && categoryleveladdons.filter(y => y.AddonId == x.AddonId));
        let tempval = false;
        for (let index = 0; index < Categoryaddons.length; index++) {
          let cat = Categoryaddons[index];
          const catval = AvailableAddon?.filter(z => z.AddonId == cat.AddonId)[0];

          if (cat && catval && cat.SelectionType == SelectionType.PerGuest && !tempval && catval.AvailableQuantity >= selectedPartySize) {
            tempval = true;
            alreadycheckval.push(Categoryaddons);
            break;
          }
          if (cat && catval && cat.SelectionType == SelectionType.PerBooking && !tempval && catval.AvailableQuantity >= addon.MinQuantity) {
            tempval = true;
            alreadycheckval.push(Categoryaddons);
            break;
          }
        }
        anyCategoryforBooking = tempval;
      }
      if (val && (val.IsUnlimited || byPartyType || byPerBooking || byLessonType || anyCategoryforBooking)) {
        addonvalue = true;
      } else {
        addonvalue = false;
        break;
      }
    }
    return addonvalue;
  }

  public static controlValidate(controls, propertyType) {
    return controls.find(x => x == propertyType) ? true : false;
  }


  }
